import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Calendar, User } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="navbar">
            <div className="container navbar-container">
                <Link to="/" className="navbar-logo">
                    <img
                        src="/logo.png"
                        alt="GeneCenter"
                        className="navbar-logo-img"
                    />
                </Link>

                {/* Desktop Menu */}
                <div className="navbar-links desktop-only">
                    <Link to="/" className="nav-link">Inicio</Link>
                    <Link to="/nosotros" className="nav-link">Nosotros</Link>
                    <Link to="/servicios" className="nav-link">Servicios</Link>
                    <Link to="/pruebas" className="nav-link">Pruebas</Link>
                    <Link to="/blog" className="nav-link">Blog</Link>
                    <Link to="/contacto" className="nav-link">Contacto</Link>
                </div>

                <div className="navbar-actions desktop-only">
                    <a href="tel:+1234567890" className="btn-icon">
                        <Phone size={20} />
                    </a>
                    <Link to="/login" className="btn btn-primary">
                        <User size={18} style={{ marginRight: '8px' }} />
                        Soy Personal
                    </Link>
                </div>

                {/* Mobile Menu Button */}
                <button className="mobile-menu-btn" onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>

                {/* Mobile Menu */}
                {isOpen && (
                    <div className="mobile-menu">
                        <Link to="/" className="mobile-link" onClick={() => setIsOpen(false)}>Inicio</Link>
                        <Link to="/nosotros" className="mobile-link" onClick={() => setIsOpen(false)}>Nosotros</Link>
                        <Link to="/servicios" className="mobile-link" onClick={() => setIsOpen(false)}>Servicios</Link>
                        <Link to="/pruebas" className="mobile-link" onClick={() => setIsOpen(false)}>Pruebas</Link>
                        <Link to="/blog" className="mobile-link" onClick={() => setIsOpen(false)}>Blog</Link>
                        <Link to="/contacto" className="mobile-link" onClick={() => setIsOpen(false)}>Contacto</Link>
                        <Link to="/login" className="btn btn-primary mobile-cta" onClick={() => setIsOpen(false)}>
                            <User size={18} style={{ marginRight: '8px' }} />
                            Soy Personal
                        </Link>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;
